<template>
  <MainLayout>
    <b-row id="criterionOverview">
      <b-col class="shadow-sm">
        <b-card-body>
          <h4
            class="card-title font-weight-bold"
            style="margin-bottom: 40px"
          >
            Übersetzungen Zuschlagsrechner
          </h4>
          <wage-supplement-type-configuration-overview />
        </b-card-body>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import WageSupplementTypeConfigurationOverview from "@/components/wageSupplement/WageSupplement.TypeConfiguration.Overview.vue";

export default {
  components: { WageSupplementTypeConfigurationOverview, MainLayout },
};
</script>

<style scoped></style>
